<template>
    <EChart
        card
        :header="$t('overview')"
        :loading="loading || isSpacesLoading"
        :error="error"
        type="time"
        height="380"
        :options="eChartOptions"
    />
</template>

<script>
    import Role from '@/Role';
    import EChart from '@/components/common/EChart.vue';
    import { generateEChartData, chartDataGroupBy } from '@/utils/chart';

    export default {
        name: 'TipsChart',
        inject: {
            parentComponent: {
                default: null,
            },
        },
        components: {
            EChart,
        },
        computed: {
            filters() {
                return this.parentComponent.filters;
            },
            isSpacesLoading() {
                return this.parentComponent.isSpacesLoading && this.userRole === Role.WIDGETER;
            },
            userRole() {
                return this.$store.getters['auth/getRoleName'];
            },
            apiParams() {
                const f = this.parentComponent.filters;

                const requestParams = {
                    startDate: f.timeRange?.startDate,
                    endDate: f.timeRange?.endDate,
                    groupBy: this.groupBy,
                    statuses: 'correct,payout_requested,paid_out',
                };

                if (f.spaces?.length) {
                    requestParams.spaces = f.spaces.map(item => item.id).join(',');
                }

                return { requestParams };
            },
            loading() {
                return this.$store.getters['tipTransactions/getLoading']('chart');
            },
            error() {
                return this.$store.getters['tipTransactions/getError']('chart');
            },
            chartData() {
                return this.$store.getters['tipTransactions/getChart'];
            },
            groupBy() {
                return chartDataGroupBy(this.filters.timeRange);
            },

            eChartData() {
                const chartItems = this.chartData.map(item => [item.date, item.amount]);
                return generateEChartData(this.filters.timeRange, chartItems, this.groupBy);
            },

            eChartOptions() {
                return {
                    legend: { show: false },
                    tooltip: {
                        valueFormatter: value => this.$format.currency(value),
                    },
                    series: [
                        {
                            type: 'bar',
                            data: this.eChartData,
                            itemStyle: {
                                color: '#5369f8',
                            },
                        },
                    ],
                };
            },
        },
        watch: {
            apiParams() {
                if (!this.parentComponent.isSpacesLoading) this.fetchData();
            },
        },
        methods: {
            fetchData() {
                this.$store.dispatch('tipTransactions/fetchChart', this.apiParams);
            },
        },
    };
</script>
